<template>
  <div>
    <!--    <van-field name="uploader" :label="label">

      <template #input>

      </template>
    </van-field> -->
    <van-cell-group :title="label">

      <van-cell v-if="!disabled">
        <template #title>
          <van-uploader :after-read="uploadPhoto" :max-count="100" @delete="DeleteFile()" @oversize="onOversize">
            <van-button icon="plus" size="small" type="primary">{{buttonName}}</van-button>
          </van-uploader>
        </template>
      </van-cell>

      <van-cell v-for="(item,index) in fileDataList" :key="index" :title="item.fileName+' - '+item.size">
        <template #right-icon>
          <div class="file-oper-box">
            <van-icon name="eye-o" size="20" color="#409EFF" v-if="item.fileType.startsWith('image')"
              @click="DownLoad(index)" />
            <van-icon v-if="!disabled" name="close" size="20" color="#F56C6C" @click="DeleteFile(index)" />
          </div>
        </template>
      </van-cell>
      <van-notice-bar v-show="fileDataList.length==0" :text="emptyMsg" />

    </van-cell-group>

    <!-- <van-image :src="src"></van-image> -->

  </div>
</template>

<script>
  import {
    ImagePreview
  } from 'vant';

  import uploadHelper from './uploadHelper/uploadHelper.js'
  export default {
    name: 'FormNormalUpload',
    data() {
      return {
        //文件上传地址
        uploadUrl: this.$utils.Url.s007 + '/api/File/UploadFile',
        //获取文件列表
        getFileListUrl: this.$utils.Url.s007 + '/api/File/FileIndex',
        //文件限制
        fileSizeLimit: this.$utils.FileSize * 1024,
        fileValue: "",
        // 图片信息
        files: {
          name: "",
          type: ""
        },
        //最后递出去的数据
        fileDataList: [

        ],
      }
    },
    props: {
      label: {
        type: String,
        default: '未定义'
      },
      placeholder: {
        type: String,
        default: '点击选择日期'
      },
      value: {
        default: ''
      },
      buttonName: {
        type: String,
        default: "上传文件"
      },
      disabled: {
        type: Boolean,
        default: false
      },
      //区分不同文件类型
      type: {
        type: String,
        default: ""
      },
      infoGuid: {
        type: String,
        default: ""
      },
      emptyMsg: {
        type: String,
        default: "暂无报告"
      }
    },
    computed: {
      // 动态计算图片列表
      imageList() {
        let that = this
        let list = []
        // 获得所有的图片
        that.fileDataList.forEach(function(item) {
          if (item.fileType.startsWith('image')) {
            let fPath = item.filePath.replace("/upload", "")
            let filePath = ""
            if (fPath.length > 1) {
              filePath = fPath
            }
            let paramStr = "?FileName=" + item.fileName + "&FilePath=" + filePath
            let url = that.$utils.Url.s007 + '/api/File/DownLoadFile' + paramStr
            list.push(url)
          }
        })
        return list
      }
    },
    watch: {
      infoGuid() {
        this.fileDataList = []
        this.initFileList()
      },
    },
    methods: {
      //个人照片上传
      uploadPhoto(file) {
        // let that = this
        this.files.name = file.file.name // 获取文件名
        this.files.type = file.file.type // 获取类型
        uploadHelper.imgPreview(file.file, this.dateImg)
        // this.uploadFile(file.file)
      },
      dateImg(base64) {
        let that = this
        let file = uploadHelper.dataURLtoFile(base64, this.files)
        that.uploadFile(file)
      },
      //文件超出限制时间
      onOversize(file) {
        console.log(file);
        this.$dialog.alert({
          title: '文件大小不能超过' + this.$utils.FileSize + 'kb'
        });
      },
      // 提交图片到后端
      uploadFile(file) {
        let that = this
        /* let formData = new window.FormData()
         formData.append('file', file) */
        // 提交图片
        // Some code
        let formData = new FormData()
        formData.append('file', file)
        that.$http.post(that.uploadUrl, formData, {
          'Content-Type': 'multipart/form-data'
        }).then(res => {
          let dataObj = res.data;
          if (dataObj.code == 0) {
			  console.log(dataObj.data[0])
            // let dataList = dataObj.data
			
				for (let key in dataObj.data[0]) {
				   dataObj.data[0][that.$utils.toLowerCaseFirst(key)] = dataObj.data[0][key]
				}
				that.setFileDataList(dataObj.data)
				// that.fileDataList.push(dataObj.data[0])
		
            //处理显示的数据
            // that.fileList = [];
            //处理返回的数据，在前台进行展示
            // that.setFileDataList(dataList)
            console.log(that.fileDataList);
          } else {
            that.$dialog({
              message: dataObj.Msg
            })
          }
        }).catch(err => {
          that.$dialog({
            message: '操作失败' + err
          })
        })
      },
      //删除文件
      DeleteFile: function(index) {
        this.fileDataList.splice(index, 1)
      },
      //下载文件
      DownLoad: function(index) {
        let that = this
        // 获得当前文件对象
        let imageModel = that.fileDataList[index]
        // 获得所有图片列表
        let fileImageList = that.fileDataList.filter(m => m.fileType.startsWith('image'))
        let imageIndex = fileImageList.indexOf(imageModel)
        console.log(imageIndex);

        ImagePreview({
          images: that.imageList, // 预览图片的那个数组
          showIndex: true,
          loop: false,
          closeable: true,
          startPosition: imageIndex, // 指明预览第几张图
        })

        // window.open(url)
      },
      //提供父辈调用获取信息
      GetFileList: function() {
        let that = this
        let fileCloneList = that.$utils.clone(this.fileDataList)
        //给数据增加type类型
        fileCloneList.forEach(function(item) {
          item.fileExtend4 = item.file_Extend4 = that.type
        })
        return fileCloneList
      },
      //初始化文件列表
      initFileList: function() {
        let that = this
        //如果没有查询文件列表需要的guid，直接跳过请求
        if (!that.infoGuid) {
          return
        }
        let params = {
          fileDataNo: that.infoGuid,
          type: that.type,
          fileExtend4:that.type,
          currentPage: 1,
          pageSize: 10000,
        }
        that.$utils.HttpPost(that.getFileListUrl, params, function(data) {
          if (data.code == 0) {
            let dataList = data.data
			dataList.forEach((item)=>{
				for (let key in item) {
				   item[that.$utils.toLowerCaseFirst(key)] = item[key]
				}
			})
            that.setFileDataList(dataList)
          }

        }, null, null, null)
      },
      setFileDataList: function(dataList) {
        let that = this
        dataList.forEach(function(dataObj) {
          dataObj.size = (parseInt(dataObj.fileSize) / 1024).toFixed(2) + "KB"
          that.fileDataList.push({
            size: dataObj.size,
            //提交对象数据
            filePath: dataObj.filePath,
            fileSize: dataObj.fileSize,
            fileType: dataObj.fileType,
            fileName: dataObj.fileName
          })
        })
      }
    },
    mounted: function() {
      // console.log(uploadHelper);
      this.initFileList()
    }
  }
</script>

<style scoped>
  .file-oper-box {
    display: flex;
    align-items: center;
  }

  .file-oper-box /deep/.van-icon {
    padding-left: 10px;
  }
</style>
